<template>
  <v-container style="overflow: auto; max-height: 400">
    <v-card class="mx-auto mb-6" :loading="loading">
      <v-alert
        prepend-icon="mdi-alert-circle-outline"
        v-if="disponiblilidadInvestigadoresAlert"
        icon="$warning"
        type="warning"
        class="custom-alert-icon"
      >
        No hay investigadores disponibles
      </v-alert>
      <v-card-title>
        <h6>DATOS DEL CASO</h6>
        <!-- <v-btn v-if="uidcliente" @click="logOut" color="primary" type="button"
          >Salir</v-btn
        > -->
        <!-- <v-btn
          v-if="uidUser"
          title="Regresar"
          @click="Regresar"
          color="primary"
          type="button"
          ><v-icon>mdi-reply-all</v-icon></v-btn
        > -->
      </v-card-title>
      <v-card-text class="text--primary px-8">
        <v-row
          v-if="
            getLogueado.cargo == 'Administrador' ||
            getLogueado.cargo == 'Call Center' ||
            getLogueado.cargo == 'Coordinador Contact Center'
          "
        >
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model="tel_asesor"
              label="Tel Asesor"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model="tel_cliente"
              label="Tel Cliente"
              required
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="2"
            v-if="
              !uidcliente &&
              (this.planesAutorizados.includes(datosCaso.tipo_plan) ||
                datosCaso.aprobar_atencion)
            "
          >
            <v-btn
              @click="enviarSms"
              title="Click, para enviar sms"
              :loading="loading"
              color="primary"
              dark
              ><v-icon dark>mdi-send</v-icon> Enviar SMS
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="2"
            v-if="
              !uidcliente &&
              datosCaso.tipo_plan === 'SIN PLAN' &&
              !datosCaso.aprobar_atencion
            "
          >
            <v-btn
              @click="solicitarAprobacion"
              title="Click, Solicitar Aprobación"
              :disabled="datosCaso.solicitud_atencion"
              dark
              color="primary"
              ><v-icon dark>mdi-checkbox-marked-circle-outline</v-icon>
              Solicitar Aprobación
            </v-btn>
          </v-col>
        </v-row>

        <v-row
          v-if="
            this.planesAutorizados.includes(datosCaso.tipo_plan) &&
            !datosCaso.solicitud_perito &&
            (getLogueado.cargo == 'Administrador' ||
              getLogueado.cargo == 'Investigador' ||
              getLogueado.cargo == 'Coordinador Investigador')
          "
        >
          <v-btn
            class="mx-3"
            dark
            @click="solicitarPerito"
            title="Solicitar perito"
            :loading="loading"
            color="primary"
            ><v-icon dark>mdi-library</v-icon> Solicitar perito
          </v-btn>
          <v-btn
            class="mx-3"
            dark
            @click="solicitarDibujante"
            title="Solicitar Dibujante"
            :loading="loading"
            color="primary"
            ><v-icon dark>mdi-library</v-icon> Solicitar Dibujante
          </v-btn>
        </v-row>
        <v-row class="pr-5">
          <v-col cols="12" sm="3" md="3">
            <p>
              # Caso: <b>{{ this.datosCaso.caso }}</b>
            </p>
            <p>
              Estado: <b>{{ this.datosCaso.estado }}</b>
            </p>
            <p>
              Tipo de Caso: <b>{{ this.datosCaso.tipocaso }}</b>
            </p>
            <p>
              Fecha Creacion: <b>{{ getDateCreacion }}</b>
            </p>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p>
              Placa: <b>{{ this.vehiculo.placa }}</b>
            </p>
            <p>
              Marca: <b>{{ this.vehiculo.marca }}</b>
            </p>
            <p>
              Linea: <b>{{ this.vehiculo.linea }}</b>
            </p>
            <p v-if="this.datosCaso.direccion_siniestro">
              Dirección:
              <b>{{
                this.datosCaso.origen_desde == "Cronos"
                  ? this.datosCronos.direccion
                  : this.datosCaso.direccion_siniestro
              }}</b>
            </p>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p>
              Cliente:
              <b>{{
                this.datosCaso.origen_desde == "Cronos"
                  ? this.datosCronos.cliente
                  : this.cliente.nombres
              }}</b>
            </p>
            <p>
              Apellidos: <b>{{ this.cliente.apellidos }}</b>
            </p>
            <p>
              CC:
              <b>{{
                this.datosCaso.origen_desde == "Cronos"
                  ? this.datosCronos.docliente
                  : this.cliente.identificacion
              }}</b>
            </p>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p>
              Ciudad:
              <b>{{
                this.datosCaso.origen_desde == "Cronos"
                  ? this.datosCronos.ciudad
                  : this.datosCaso.ciudad_siniestro
              }}</b>
            </p>
            <p>
              Abogado:
              <b>{{ nombreAbogado || "SIN ASIGNAR" }}</b>
            </p>
            <p>
              Investigador:
              <b>{{ nombreInvestigador || "SIN ASIGNAR" }}</b>
            </p>
          </v-col>
        </v-row>
        <v-row v-if="showPoliza">
          <v-btn
            class="mx-3"
            dark
            @click="ConsultasPolizaVehiculo"
            title="Consultar póliza vehículo"
            :loading="loading"
            color="primary"
            ><v-icon dark>mdi-magnify</v-icon> Consultar póliza
          </v-btn>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- datos de la poliza -->
    <datos-poliza
      v-if="
        datosCaso.origen == 'Tecnicar' || datosCaso.origen == 'SEGURO TERCERO'
      "
      :showPoliza.sync="showPoliza"
    ></datos-poliza>
    <!-- find datos de la póliza -->
    <v-card class="mx-auto" :loading="loading">
      <v-card-text>
        <v-card-title>
          <h6>HISTORIAL DE GESTIÓN</h6>
        </v-card-title>
        <div v-for="(his, indice) in trazabilidad" :key="his.id">
          <span class="mt-2 mb-1 primary--text"
            ># {{ trazabilidad.length - indice }} Gestión</span
          >
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <p class="caption pt-2">
                {{ fechaGestion(his.fechahora) }}:
                {{ his.descripcion }}
              </p>
              <p class="caption pt-2" v-if="his.nameArchivo != 'no'">
                <a @click="descargar(his.nameArchivo)">{{ his.nameArchivo }}</a>
              </p>
            </v-col>
          </v-row>
          <v-divider class="mr-6 mb-3"></v-divider>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { db, ref, storage, getDownloadURL } from "../../firebase";
import moment from "moment";
// eslint-disable-next-line no-unused-vars
import CryptoJS from "crypto-js/crypto-js";
import { mapActions, mapGetters } from "vuex";
import DatosPoliza from "./DatosPoliza.vue";
import WebServiceHub from "@/helpers/WebServiceHub";
import WebServiceTecnicar from "@/helpers/WebServiceTecnicar";
// import axios from "@/util/axiosConfig";
import axios from "axios";

export default {
  name: "InfoCaso",
  data() {
    return {
      loading: true,
      datosCaso: {},
      vehiculo: {},
      cliente: {},
      abogado: {},
      investigador: {},
      trazabilidad: {},
      gestion: "Gestion",
      // `:id` en la ruta es opcional; si viene vacío Firestore falla con doc("").
      id: "",
      ciudad: "",
      tel_asesor: 0,
      tel_cliente: 0,
      shortURLS: [],
      registration_ids: [],
      crearChat: {},
      poliza: {
        encontrado: false,
      },
      showPoliza: false,
      planesAutorizados: ["SEGURO TERCERO", "RC PUBLICO", "RC Publico"],
      tipoPlan: "SIN PLAN",
      datosCronos: {},
      disponiblilidadInvestigadoresAlert: false,
      ambiente: process.env.VUE_APP_AMBIENTE,
    };
  },
  components: {
    DatosPoliza,
  },
  async mounted() {},
  async created() {
    // Resolver id del caso desde ruta o localStorage.
    this.id = (
      this.$route?.params?.id ||
      localStorage.getItem("id") ||
      ""
    ).trim();
    if (!this.id) {
      this.handleError({
        message:
          "No se pudo determinar el ID del caso. Vuelve a abrir el caso desde la lista.",
      });
      return;
    }

    this.tel_asesor = this.$store.state.logueado?.telefono || 0;
    try {
      // Cargar el caso al menos una vez ANTES de usar sus UIDs.
      const casoInicial = await db.collection("casos").doc(this.id).get();
      this.datosCaso = casoInicial.exists ? casoInicial.data() || {} : {};

      await db
        .collection("trazabilidad")
        .where("uidcaso", "in", [this.id])
        .orderBy("fechahora", "desc")
        .onSnapshot((snap) => {
          const resul = snap.docs.map((e) => e.data());
          this.trazabilidad = resul;
          // console.log(this.trazabilidad);
        });
      await db
        .collection("casos")
        .doc(this.id)
        .onSnapshot((doc) => (this.datosCaso = doc.data()));
      const cronos = await db
        .collection("polizas")
        .where("idCaso", "==", this.id)
        .get();
      const resultCronos = cronos.docs.map((e) => ({
        ...e.data(),
      }));
      this.datosCronos = resultCronos[0];
      await this.getData();
    } catch (error) {
      this.handleError(error);
    }
  },
  computed: {
    ...mapGetters(["getLogueado"]),
    url() {
      // return `http://localhost:8080/login/auth-cliente/${this.id}`;
      return `https://sandbox.digipats.com.co/login/auth-cliente/${this.id}`;
      // return `https://digipats.com.co/login/auth-cliente/${this.id}`;
    },
    getDateCreacion() {
      return moment(this.datosCaso.creado).format("YYYY-MM-DD HH:mm:ss");
    },
    uidcliente() {
      return localStorage.getItem("cliente");
    },
    uidUser() {
      return localStorage.getItem("user");
    },
    nombreAbogado() {
      return (
        this.abogado.nombres &&
        this.abogado.apellidos &&
        `${this.abogado.nombres} ${this.abogado.apellidos}`
      );
    },
    nombreInvestigador() {
      return (
        this.investigador.nombres &&
        this.investigador.apellidos &&
        `${this.investigador.nombres} ${this.investigador.apellidos}`
      );
    },
  },
  methods: {
    ...mapActions("notification", ["EnviarNotificaciones"]),
    async getData() {
      try {
        // const datos = await db.collection("casos").doc(this.id).get();
        const uidvehiculo = this.datosCaso?.uidvehiculo;
        const uidconductor = this.datosCaso?.uidconductor;
        const esSalesforce =
          this.datosCaso?.origen_desde === "Salesforce" ||
          this.datosCaso?.origen === "Salesforce";

        // Casos Salesforce: los datos vienen “planos” en el documento del caso.
        if (esSalesforce || (!uidvehiculo && !uidconductor)) {
          this.vehiculo = {
            placa: this.datosCaso?.placa || "",
            marca: this.datosCaso?.marca || "",
            linea: this.datosCaso?.linea || "",
          };
          this.cliente = {
            nombres: this.datosCaso?.nombre_usuario || "",
            apellidos: this.datosCaso?.apellidos_usuario || "",
            identificacion: this.datosCaso?.numero_documento_usuario || "",
            telefono:
              this.datosCaso?.telefono_usuario_1 ||
              this.datosCaso?.telefono_usuario_2 ||
              this.datosCaso?.telefono_usuario_3 ||
              "",
            correo: this.datosCaso?.correo_usuario || "",
          };
          if (this.cliente?.telefono) {
            this.tel_cliente = `${this.cliente.telefono}`;
          }
          // Abogado / Investigador en Salesforce suelen venir vacíos; si vienen, se consultan abajo.
          this.loading = false;
          return;
        }

        const vehiculo = await db
          .collection("vehiculos")
          .doc(uidvehiculo)
          .get();
        this.vehiculo = vehiculo.data() || "";
        const cliente = await db.collection("clientes").doc(uidconductor).get();
        this.cliente = cliente.data() || "";

        if (this.cliente) {
          this.tel_cliente = this.cliente.telefono;
        }

        if (this.datosCaso?.uidabogado) {
          const abogado = await db
            .collection("usuarios")
            .doc(this.datosCaso.uidabogado)
            .get();
          this.abogado = abogado.data() || "";
        }
        if (this.datosCaso?.uidinvestigador) {
          const investigador = await db
            .collection("usuarios")
            .doc(this.datosCaso.uidinvestigador)
            .get();
          this.investigador = investigador.data() || "";
        }
        // const ciudad = await db
        //   .collection("ciudades")
        //   .doc(this.datosCaso.uidciudad)
        //   .get();
        // console.log(ciudad.data().ciudad);
        // this.ciudad = ciudad.data().ciudad || "";
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
    descargar(nameArchivo) {
      getDownloadURL(ref(storage, `DocGestion/${nameArchivo}`))
        .then((url) => {
          window.open(url, "_blank");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async enviarSms() {
      // console.log(this.id);
      await db.collection("casos").doc(this.id).update({
        login: false,
      });
      this.loading = true;
      try {
        // sandbox - production
        const url =
          this.ambiente === "sandbox"
            ? process.env.VUE_APP_CLOUDFUNCTIONURL_SANDBOX
            : process.env.VUE_APP_CLOUDFUNCTIONURL;
        const response = await axios.post(`${url}/acortar_url/codigo`, {
          url: this.url,
        });
        const { codigo } = response.data;
        this.shortURLS = [codigo];
        await this.sms(`https://tyl.fyi/${codigo}`);
      } catch (error) {
        console.log(error);
      }
      await this.disponibilidadInvestigadores();
    },
    async disponibilidadInvestigadores() {
      //
      const querySnapshot = await db
        .collection("usuarios")
        .where("cargo", "==", "Investigador")
        .where("estado", "==", true)
        .where("disponibilidad", "in", ["Activo en espera"])
        .get();

      if (querySnapshot.empty) {
        console.log("No hay investigadores disponibles");
        this.disponiblilidadInvestigadoresAlert = true;
      }
    },
    async solicitarPerito() {
      const swal = await this.$swal({
        title: "Solicitud",
        text: `¿Esta seguro solicitar un perito al caso # ${this.datosCaso.caso}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si, Solicitar !!",
        cancelButtonText: "No",
        cancelButtonColor: "#d33",
      });

      if (swal.isConfirmed) {
        try {
          await this.crearChatPeritoDibujante(
            "chatsperito",
            this.datosCaso.solicitud_perito
          );
          db.collection("casos")
            .doc(this.id)
            .update({ solicitud_perito: true, chat_perito: true });
          await this.$store.dispatch("trazabilidadCaso", {
            descripcion: `El ${this.getLogueado.cargo} ha solicitado un perito al caso # ${this.datosCaso.caso}`,
            uidcaso: this.id,
            uidcreador: this.getLogueado.id,
          });
          await this.TokensNotificaciones(); // Token para envió de notificaciones
          this.$swal("Operación Exitosa", "", "success");
          await this.getData();
        } catch (error) {
          console.log(error);
        }
      }
    },
    async solicitarDibujante() {
      const swal = await this.$swal({
        title: "Solicitud",
        text: `¿Esta seguro solicitar dibujante al caso # ${this.datosCaso.caso}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si, Solicitar !!",
        cancelButtonText: "No",
        cancelButtonColor: "#d33",
      });

      if (swal.isConfirmed) {
        try {
          await this.crearChatPeritoDibujante(
            "chatsdibujante",
            this.datosCaso.solicitud_dibujante
          );
          db.collection("casos").doc(this.id).update({
            solicitud_dibujante: true,
            uiddibujante: "solicitado",
            chat_dibujante: true,
          });
          await this.$store.dispatch("trazabilidadCaso", {
            descripcion: `El ${this.getLogueado.cargo} ha solicitado un dibujante al caso # ${this.datosCaso.caso}`,
            uidcaso: this.id,
            uidcreador: this.getLogueado.id,
          });
          await this.TokensNotificaciones(); // Token para envió de notificaciones
          this.$swal("Operación Exitosa", "", "success");
          await this.getData();
        } catch (error) {
          console.log(error);
        }
      }
    },
    async ConsultasPolizaVehiculo() {
      try {
        this.loading = true;
        const hub = new WebServiceHub();
        const planHub = await hub.consultarVehiculo(this.vehiculo.placa);
        const tecnicar = new WebServiceTecnicar();
        const planTenicar = await tecnicar.get(
          `kronos?placa=${this.vehiculo.placa}`
        );
        if (planHub.vehicle) {
          const fechaFin = moment(
            planHub.policy_end_date,
            "D/M/YYYY hh:mm:ss a"
          ).format("YYYY-MM-DD");
          this.poliza = {
            encontrado: true,
            nombre_producto: planHub.policy_origin,
            polizas: planHub.policy_number,
            fechaIni: moment(
              planHub.policy_start_date,
              "D/M/YYYY hh:mm:ss a"
            ).format("YYYY-MM-DD"),
            fechaFin: fechaFin,
          };
          // SEGURO TERCERO
          this.tipoPlan = "SEGURO TERCERO";
        }
        if (planTenicar.status === 200) {
          this.poliza = { ...planTenicar, encontrado: true };
          //RC PUBLICO
          this.tipoPlan = "RC PUBLICO";
        }
        if (!this.poliza.encontrado) {
          throw new Error("No se encontró la póliza del vehículo");
        }
        // consultamos la poliza
        await db
          .collection("polizas")
          .where("idCaso", "in", [this.id])
          .onSnapshot((snap) => {
            const resul = snap.docs.map((e) => {
              const data = e.data();
              data.id = e.id;
              return data;
            });
            const datosPoliza = resul.find((el) => {
              return el;
            });
            if (datosPoliza) {
              db.collection("polizas")
                .doc(datosPoliza.id)
                .update({
                  ...this.poliza,
                  caso: this.datosCaso.caso,
                  idCaso: this.id,
                  uidcliente: this.uidcliente,
                  uidvehiculo: this.vehiculo.id,
                });
            } else {
              db.collection("polizas").add({
                ...this.poliza,
                caso: this.datosCaso.caso,
                idCaso: this.id,
                uidcliente: this.uidcliente,
                uidvehiculo: this.vehiculo.id,
              });
            }
          });
        await db.collection("casos").doc(this.id).update({
          tipo_plan: this.tipoPlan,
        });
        this.$swal({
          icon: "success",
          title: "OK",
          text: "Poliza consultada exitosamente",
        });
        await this.getData();
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
    async TokensNotificaciones() {
      // Consultar tokens de los coordinadores de contact center para enviar notificaciones
      try {
        const usuarios = await db
          .collection("usuarios")
          .where("cargo", "in", ["Coordinador Perito"])
          .get();

        const objUsuNotificar = usuarios.docs.map((e) => ({
          ...e.data(),
        }));

        const usu = objUsuNotificar
          .filter((e) => {
            return e.tokenPush;
          })
          .map((u) => {
            return u.tokenPush;
          });

        this.registration_ids = [...usu];
        this.registration_ids.length > 0 &&
          (await this.EnviarNotificaciones({
            registration_ids: this.registration_ids,
            title: "Solicitud",
            message: `El ${this.getLogueado.cargo} ha solicitado un perito al caso #${this.datosCaso.caso}`,
          }));
      } catch (error) {
        console.log(error);
      }
    },
    async sms(enlace) {
      try {
        let numero = this.tel_cliente.trim();
        const url =
          this.ambiente === "sandbox"
            ? process.env.VUE_APP_CLOUDFUNCTIONURL_SANDBOX
            : process.env.VUE_APP_CLOUDFUNCTIONURL;
        const response = await axios.post(`${url}/enviar_mensaje_plantilla`, {
          template: "digipats-aprobacion-atencion",
          phone: numero,
          params: { enlace },
        });
        if (response.data.status === 401) {
          throw new Error(response.data.message);
        }
        this.$swal({ icon: "success", title: "OK", text: "Mensaje enviado!" });
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "No se logro enviar el mensaje",
        });
      }
    },
    async crearChatPeritoDibujante(coleccion, solicitud) {
      try {
        if (solicitud) return;
        // console.log("crear chat");
        // eslint-disable-next-line
        // this.crearChat.avatar =
        //"https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Flogo.png?alt=media&token=ac1de4f6-5fb5-4326-a944-4baaf85c46a9";
        this.crearChat.avatar =
          "https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Fvml.ico?alt=media&token=d93de8fc-dc76-4c53-bb6e-f8420d814827";
        this.crearChat.roomName = "Chat en proceso (Entrar)";
        this.crearChat.uidcaso = this.id;
        this.crearChat.unreadCoun = 0;
        this.crearChat.users = [];
        // console.log(this.crearChat, "chat");
        const resChat = await db.collection(coleccion).add(this.crearChat);
        await db
          .collection(coleccion)
          .doc(resChat.id)
          .update({ roomId: resChat.id });
      } catch (error) {
        console.log(error);
      }
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
    logOut: function () {
      this.$store.dispatch("ActualizarLoginCliente", {
        id: this.id,
        login: false,
      });
      this.$store.commit("salirCliente");
      this.$router.push(`/login/auth-cliente/${this.id}`).catch(() => {});
    },
    fechaGestion(fecha) {
      return moment(fecha).format("YYYY-MM-DD HH:mm:ss");
    },
    Regresar() {
      this.$router.push("/casos").catch(() => {});
    },
    async solicitarAprobacion() {
      const confirm = await this.$swal({
        title: "¿Solicitar aprobación?",
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "Cancelar",
      });

      if (confirm.isConfirmed) {
        try {
          await db
            .collection("casos")
            .doc(this.id)
            .update({ solicitud_atencion: true });

          this.$store.dispatch("trazabilidadCaso", {
            descripcion:
              "Solicitud de aprobación para la atención del caso sin plan",
            uidcaso: this.id,
            uidcreador: this.getLogueado.id,
          });
          // Consultar tokens de los coordinadores de contact center para enviar notificaciones
          const usuarios = await db
            .collection("usuarios")
            .where("cargo", "in", [
              "Administrador",
              "Coordinador Contact Center",
            ])
            .get();

          const objUsuNotificar = usuarios.docs.map((e) => ({
            ...e.data(),
          }));

          const usu = objUsuNotificar
            .filter((e) => {
              return e.tokenPush;
            })
            .map((u) => {
              return u.tokenPush;
            });

          this.registration_ids = [...usu];
          // this.$store.dispatch("EnviarNotificaciones", {
          //   registration_ids: this.registration_ids,
          //   title: "Solicitud de aprobación",
          //   message: `Se ha solicitado aprobación de atención para el caso #${this.datosCaso.caso}`,
          // });
          this.EnviarNotificaciones({
            registration_ids: this.registration_ids,
            title: "Solicitud de aprobación",
            message: `Se ha solicitado aprobación de atención para el caso #${this.datosCaso.caso}`,
          });
          await this.getData();
        } catch (error) {
          this.handleError({ message: "Error al solicitar aprobación" });
        }
      }
    },
  },
};
</script>
<style scope>
.v-card__title {
  display: flex;
  justify-content: space-between;
  text-align: center;
}

.col-btn-sms {
  display: flex;
  justify-content: center;
  align-items: center;
}
.custom-alert-icon .v-icon {
  background-color: rgb(251, 246, 246);
  color: orange;
  font-weight: bold;
}
</style>
